import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { mutationDeleteAgent } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import ConfirmModal from "module-common/ConfirmModal";

export default graphql(mutationDeleteAgent)(
  class DeleteButton extends Component {
    static propTypes = { id: PropTypes.number };
    state = { showModal: false };

    render() {
      return [
        <Icon
          key="trash"
          name="recycle-bin"
          onClick={() => this.setState({ showModal: true })}
        />,
        this.state.showModal && (
          <ConfirmModal
            key="modal"
            text="Do you want to delete this agent?"
            onCancel={() => this.setState({ showModal: false })}
            onConfirm={this.onConfirm}
          />
        )
      ];
    }

    onConfirm = () => {
      try {
        this.props.mutate({
          variables: {
            agent: {
              id: this.props.id
            }
          },
          refetchQueries: ["getAgents"]
        });
        ShowNotice("team-agent-delete-success");
      } catch (error) {
        ShowNotice("team-agent-delete-error");
      }
      this.setState({ showModal: false });
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/team-panel/DeleteButtonWithMutation.js